import { FC } from 'react'
import { MarketingPageRoutes, Routes } from '@dtx-company/true-common/src/constants/routes'
import { StyledLinkText, StyledText } from './AuthForm.styles'
import Link from 'next/link'

export const Disclaimer: FC<{
  onClickTermsOfService?: () => void
  onClickPrivacy?: () => void
  invertColor?: boolean
}> = ({ onClickTermsOfService, onClickPrivacy, invertColor }) => (
  <StyledText textAlign="center" variant="general/captionAndLabel" invertColor={invertColor}>
    By continuing, you agree to Flowcode&apos;s&nbsp;
    <Link
      href={MarketingPageRoutes.TERMS_OF_SERVICE}
      target="_blank"
      onClick={onClickTermsOfService}
    >
      <StyledLinkText
        as="span"
        textDecoration="underline"
        fontSize="inherit"
        invertColor={invertColor}
      >
        Terms of Service
      </StyledLinkText>
    </Link>
    &nbsp; and &nbsp;
    <Link href={Routes.PRIVACY_POLICY} target="_blank" onClick={onClickPrivacy}>
      <StyledLinkText
        as="span"
        textDecoration="underline"
        fontSize="inherit"
        invertColor={invertColor}
      >
        Privacy Policy
      </StyledLinkText>
    </Link>
    .
  </StyledText>
)
